<template>
    <div class="list">
        <div class="list">
            <div>
                <div v-for="(item,index) in list">
                    <div class="media media-2 media-3">
                        <a :href="`/news/topic/${item.id}`" >
                            <div class="media-left" :style="'background: url('+item.img_url[0]+') center no-repeat; background-size: cover;'"></div>
                            <div class="media-body elip">{{item.title}}</div>
                        </a>
                    </div>
                  <div class="media">
                        <ul>
                            <a v-for="(relation,i) in item.childs" :href="`/news/${relation.id}`">
                                <li>{{relation.title}}<span>{{friendlyTime(relation.released_at)}}</span></li>
                            </a>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import friendlyTime from 'asset/js/utils/friendlyTime';
import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);
    export default {
        props: ['list'],
        components: {},
        data() {
            return {
                friendlyTime
            }
        }
    };
</script>


// WEBPACK FOOTER //
// app/web/component/web/news-list/img-list.vue